import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { QuestionManagementService } from '../../../Services/question-management/question-management.service';
import { SessionService } from '../../../Services/session.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-fa-question-usage-setting',
  templateUrl: './question-usage-setting.component.html',
  styleUrls: ['./question-usage-setting.component.css'],
})
export class QuestionUsageSettingComponent implements OnInit {
  @Input() subjectById: any;
  @Input() selectedQuestionById: any;
  @Output() closequestionusage: EventEmitter<any> = new EventEmitter<any>();
  QuestionNo: any;
  SubjectID: any;
  constructor(
    public toastr: ToastrService,
    public service: QuestionManagementService,
    public session: SessionService
  ) {}

  ngOnInit(): void {
    this.getBreadcrumbDetails();
    this.getCategory();
    this.getDiffcultlevel();
    this.getQuestionScope();
    this.QuestionNo = this.selectedQuestionById[0].Question_ID;
    this.SubjectID = this.subjectById.Subject_Id;
    this.getQuestionUsage({
      QuestionID: this.QuestionNo,
      SubjectID: this.SubjectID,
    });
  }

  Breadcrumblist: any;
  getBreadcrumbDetails() {
    this.service
      .getBreadcrumbDetails({ ID: this.subjectById.Subject_Id })
      .subscribe(
        (i: any) => {
          this.Breadcrumblist = i;
          // }).catch((e: any) => {
          //   this.subjectById = null;
          // }
          // )
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getcategory: any;
  getCategory() {
    this.service.GetCode({ Tablename: 'EXAM_CATEGORY' }).subscribe(
      (i: any) => {
        this.getcategory = i;
        console.log(this.getcategory, 'getcategory');
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  getquestionscope: any;
  getQuestionScope() {
    this.service.GetCode({ Tablename: 'QUESTION_SCOPE_TYPE' }).subscribe(
      (i: any) => {
        this.getquestionscope = i;
        console.log(this.getquestionscope, 'getquestionscope');
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  getdifficultlevel: any;
  getDiffcultlevel() {
    this.service.GetCode({ Tablename: 'DIFFICULTY_LEVEL_TYPE' }).subscribe(
      (i: any) => {
        this.getdifficultlevel = i;
        console.log(this.getdifficultlevel, 'getdifficultlevel');
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  getQuestionUsagelist: any;
  response: any;
  getQuestionUsage(data: any) {
    this.service.GetQuestionUsageSetting(data).subscribe(
      (i: any) => {
        this.response = i;
        this.getQuestionUsagelist = this.response.data;
        if (this.getQuestionUsagelist != null) {
          if (this.getQuestionUsagelist.length == 0) {
            this.deletedQuestionlist = [];
            this.addvalue();
          } else {
            this.getQuestionUsagelist.map(
              (obj: { DeleteInd: string; EditFlag: boolean }) => {
                obj.EditFlag = false;
                obj.DeleteInd = 'N';
                return obj;
              }
            );
            this.deletedQuestionlist = [];
          }
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  addvalue() {
    let list: any = {};
    (list['Question_ID'] = this.QuestionNo),
      (list['Question_Usage_Setting_ID'] = null),
      (list['Exam_Category_Type_Code'] = ''),
      (list['Exam_Category_Type_Name'] = ''),
      (list['Difficulty_Level_Type_Code'] = ''),
      (list['Difficulty_Level_Type_Name'] = ''),
      (list['Question_Scope_Type_Code'] = ''),
      (list['Question_Scope_Type_Name'] = ''),
      (list['DIFFICULTY_LEVEL'] = ''),
      (list['QUESTION_SCOPE'] = ''),
      (list['EXAM_CATEGORY'] = ''),
      (list['EditFlag'] = true),
      (list['DeleteInd'] = 'N'),
      this.getQuestionUsagelist.push(list);
    console.log(this.getQuestionUsagelist);
    //this.ValidateExamCategory();
  }

  value: any;
  selectcategory(event: string, index: number) {
    this.getQuestionUsagelist[index].Exam_Category_Type_Code = '';
    //  this.value='EXAM_MASTER@'+event;
    //  console.log(this.value,'EXAM_MASTER')
    //  this.getExamMaster(this.value);
    this.ValidateExamCategory(event, index);
  }

  selectdifficult(event: string, index: number) {
    this.getQuestionUsagelist[index].Difficulty_Level_Type_Code = event;
  }

  selectscope(event: string, index: number) {
    this.getQuestionUsagelist[index].Question_Scope_Type_Code = event;
  }

  deletedQuestionlist: any[] = [];
  removevalue(i: number) {
    if (!this.getQuestionUsagelist[i].Question_Usage_Setting_ID) {
      this.getQuestionUsagelist.splice(i, 1);
      if (this.getQuestionUsagelist.length == 0) {
        this.addvalue();
      }
    } else {
      this.getQuestionUsagelist[i].DeleteInd = 'Y';
      this.deletedQuestionlist.push(this.getQuestionUsagelist[i]);
      this.getQuestionUsagelist.splice(i, 1);
      if (this.getQuestionUsagelist.length == 0) {
        this.addvalue();
      }
    }
    //this.ValidateExamCategory();
  }
  Editvalue(index: number) {
    this.getQuestionUsagelist[index].EditFlag = true;
  }

  check: boolean;
  insertresponse: any;
  save() {
    let UDTQuestionUsageSettinglist: any[] = [];

    //validate initial iteration
    if (this.deletedQuestionlist.length > 0) {
      if (this.getQuestionUsagelist.length == 1) {
        for (let i = 0; i < this.getQuestionUsagelist.length; i++) {
          if (
            !this.getQuestionUsagelist[i].Exam_Category_Type_Code ||
            !this.getQuestionUsagelist[i].Difficulty_Level_Type_Code ||
            !this.getQuestionUsagelist[i].Question_Scope_Type_Code
          ) {
            this.getQuestionUsagelist.splice(i, 1);
          }
        }
      }
    }
    //merge the deleted list with main list
    if (this.deletedQuestionlist) {
      for (let item of this.deletedQuestionlist) {
        this.getQuestionUsagelist.unshift(item);
      }
    }

    this.getQuestionUsagelist.forEach(
      (element: {
        Question_Usage_Setting_ID: any;
        Question_ID: any;
        Exam_Category_Type_Code: any;
        Difficulty_Level_Type_Code: any;
        Question_Scope_Type_Code: any;
        DeleteInd: any;
      }) => {
        let tempListlet: any = {};
        (tempListlet['QuestionUsageSettingId'] =
          element.Question_Usage_Setting_ID),
          (tempListlet['QuestionId'] = element.Question_ID),
          (tempListlet['ExamCategoryTypeCode'] =
            element.Exam_Category_Type_Code),
          (tempListlet['DifficultyLevelTypeCode'] =
            element.Difficulty_Level_Type_Code),
          (tempListlet['QuestionScopeTypeCode'] =
            element.Question_Scope_Type_Code),
          (tempListlet['DeleteInd'] = element.DeleteInd);
        UDTQuestionUsageSettinglist.push(tempListlet);
      }
    );
    if (UDTQuestionUsageSettinglist) {
      this.check = false;
      for (let item of UDTQuestionUsageSettinglist) {
        if (
          !item.ExamCategoryTypeCode ||
          !item.DifficultyLevelTypeCode ||
          !item.QuestionScopeTypeCode
        ) {
          this.check = true;
          this.getQuestionUsagelist.splice(0, this.deletedQuestionlist.length);
          break;
        }
      }
      if (!this.check) {
        let tempList = {
          UDTQuestionUsageSetting: UDTQuestionUsageSettinglist,
        };
        this.service.InsertOrUpdateQuestionUsage(tempList).subscribe(
          (res) => {
            console.log(res);
            this.insertresponse = res;
            if (this.insertresponse.Message == 'Success') {
              this.toastr.success('Success!');
              //this.getExamAgenecy();
              this.QuestionNo = this.selectedQuestionById[0].Question_ID;
              this.SubjectID = this.subjectById.Subject_Id;
              this.getQuestionUsage({
                QuestionID: this.QuestionNo,
                SubjectID: this.SubjectID,
              });
              console.log(res);
            } else {
              this.toastr.error(this.insertresponse.Message);
            }
          },
          (error) => {
            this.toastr.error('ERROR!', this.insertresponse.Message);
          }
        );
      } else {
        this.toastr.error('Please choose all value');
      }
    } else {
      this.toastr.error('No data to Save');
    }
  }

  Cancel() {
    this.closequestionusage.emit(1);
  }

  validate(index: any): boolean {
    let count = -1;
    for (let i = 0; i < this.getQuestionUsagelist.length; i++) {
      if (this.getQuestionUsagelist[i].DeleteInd == 'N') {
        count++;
      } else {
        if (
          !this.getQuestionUsagelist[this.getQuestionUsagelist.length - 1]
            .Question_Usage_Setting_ID
        ) {
          count++;
        }
      }
    }
    if (index == count) {
      return true;
    } else {
      return false;
    }
  }

  booksByStoreID: any;
  compare: any;
  validate1(index: number): boolean {
    this.booksByStoreID = this.getQuestionUsagelist.filter(
      (getQuestionUsagelist: { DeleteInd: string }) =>
        getQuestionUsagelist.DeleteInd === 'N'
    );
    console.log(this.booksByStoreID.length, 'booksByStoreID');

    // if(index>this.booksByStoreID.length){
    //   index=(index-this.booksByStoreID.length);
    // }

    if (this.booksByStoreID.length - 1 == index) {
      return true;
    } else {
      return false;
    }
  }

  restrictexam: boolean = false;
  ValidateExamCategory(event: string, index: number) {
    //     this.getQuestionUsagelist.forEach( (array1Ttem: {
    //       DeleteInd: string; Exam_Category_Type_Code: any;
    // }) => {
    //       this.getcategory.forEach( (array2Item: {
    //         Code: any; Exam_Category_Type_Code: any; DeleteInd: string;
    // }) => {
    //          if((array1Ttem.Exam_Category_Type_Code == array2Item.Code)&&(array1Ttem.DeleteInd=='N')){
    //           this.getcategory.splice(array2Item, 1);
    //         }
    //       })
    //     })
    this.restrictexam = false;

    for (let i = 0; i < this.getQuestionUsagelist.length; i++) {
      if (i != index) {
        if (
          this.getQuestionUsagelist[i].Exam_Category_Type_Code == event &&
          this.getQuestionUsagelist[i].DeleteInd == 'N'
        ) {
          this.restrictexam = true;
          break;
        }
      }
    }

    //   for (let item of this.getQuestionUsagelist) {
    //   if((item.Exam_Category_Type_Code==event)&&(item.DeleteInd=='N'))
    //   {
    //     this.restrictexam=true;
    //     break;
    //   }
    // }

    if (!this.restrictexam) {
      this.getQuestionUsagelist[index].Exam_Category_Type_Code = event;
    } else {
      this.getQuestionUsagelist[index].Exam_Category_Type_Code = event;
      this.Duplicatealertpopup(index);
      //this.getCategory();
    }
  }

  clearform() {
    this.getQuestionUsagelist[this.Indexvalue].Exam_Category_Type_Code = '';

    this.Duplicatealertpopup(1);
  }

  alertflag: boolean;
  Indexvalue: any;
  Duplicatealertpopup(index: any) {
    this.Indexvalue = index;
    this.alertflag = !this.alertflag;
  }
}
